import{__require as r}from"../InputData.mjs";var t,e;function n(){if(e)return t;e=1;const n=r();return t=(r,t)=>{let e=new n(r);for(let r in t)e.add(r,t[r]);return e.data}}export{n as __require};
